import { Service, ServiceApi, ServiceFormData, ServiceFormDataApi, ServiceFormErrors, ServiceFormErrorsApi } from '../types'

export class ServiceMappers {
  public static fromApi(service: ServiceApi): Service {
    return {
      id: service.id,
      name: service.service_name,
      price: parseFloat(service.service_price),
      category: { id: service.service_category_id, name: service.service_category_name },
      status: { id: service.state_id, name: service.state_name },
      isAppointment: !!service.accepted,
    }
  }

  public static manyFromApi(raw: ServiceApi[]): Service[] {
    return raw.map((item) => this.fromApi(item))
  }

  public static formDataToApi(formData: ServiceFormData): ServiceFormDataApi {
    return {
      service_id: formData.id,
      service_name: formData.name,
      service_category_id: formData.categoryId,
      service_price: formData.price,
      state_id: formData.statusId,
      accepted: Number(formData.isAppointment).toString(),
    }
  }

  public static formErrorsFromApi(errors: ServiceFormErrorsApi): ServiceFormErrors {
    return {
      id: errors.service_id?.join(', '),
      name: errors.service_name?.join(', '),
      price: errors.service_price?.join(', '),
      categoryId: errors.service_category_id?.join(', '),
      statusId: errors.state_id?.join(', '),
      isAppointment: errors.accepted?.join(', '),
      _custom: errors._custom?.join(', '),
    }
  }

  public static formInitializer(service: Service): ServiceFormData {
    return {
      id: service.id.toString(),
      name: service.name,
      categoryId: service.category.id.toString(),
      statusId: service.status.id.toString(),
      price: service.price.toString(),
      isAppointment: service.isAppointment,
    }
  }
}
